import { Dept } from '../../model/tenant/dept';
import { DictDataParam } from '../dict-data/dict-data-param';
import { DictDataParamType } from '../dict-data/dict-data-param-type.enum';
import { DictDataType } from '../dict-data/dict-data-type.enum';
import { Injectable } from '@angular/core';
import { NecDictDataService } from '../dict-data/dict-data.service';
import { Observable } from 'rxjs';


@Injectable()
export class NecDeptService {

  constructor(private dicService: NecDictDataService) {
  }

  getDeptsByTenantId(tenantId: number): Observable<Dept[]> {
    return this.dicService.getDictData(DictDataType.TENANT_DEPTS, new DictDataParam(tenantId, DictDataParamType.TENANT));
  }

  /**
   * è·åè¢«å®ä¹ä¸ºç®¡çåçç§å®¤list
   */
  getDefinedDeptsByUserId(userId: number): Observable<Dept[]> {
    return this.dicService.getDictData(DictDataType.MY_DEFINED_DEPTS, new DictDataParam(userId, DictDataParamType.TENANT));
  }

}
